<template>
    <div>
        <div class="items">
            <div class="item card-white""> <!-- :class="{ 'margin-200-top': status.complete } -->

                <div class="card margin-card" v-if="!status.complete">
                  <eyebrow-icon v-if="true" v-bind:eyebrowicon="{'icon':'star-outline', 'color':'black'}" v-bind:align="'center'"></eyebrow-icon>
                  <h4>Share your feedback on AirMini</h4>
                </div>

                <form id="ContactForm" ref="contact_form" class="contact-form" action="javascript:" v-on:submit.prevent="submit">

                    <div v-if="!status.complete">

                        <div class="group">
                          <label for="notPurchasedReason">Why haven’t you purchased an AirMini yet?</label>
                          <select class="validation selectOptGroup"
                                  id="notPurchasedReason"
                                  v-bind:class="{ '-invalid': validation.notPurchasedReason }"
                                  v-model="fields.notPurchasedReason"
                                  @change="updateView">
                            <option selected disabled value="">Select from the following options...</option>
                            <option value="Don't see the need">Don't see the need</option>
                            <option value="Too expensive">Too expensive</option>
                            <option value="No payment plan offered">No payment plan offered</option>
                            <option value="I can't use my mask with it">I can't use my mask with it</option>
                            <option value="I don't travel">I don't travel</option>
                            <option value="Haven't purchased yet; still deciding">Haven't purchased yet; still deciding</option>
                            <option data-nextstep="[1]" value="Other">Other</option>
                          </select>
                          <div class="error-message" v-for="message in validation.notPurchasedReason">{{ message }}</div>
                        </div>

                        <div v-if="status.step.indexOf(1) != -1" class="group">
                           <label for="dislikeReason">Other reason</label>
                           <textarea class="validation"
                                     v-bind:class="{ '-invalid': validation.dislikeReason }"
                                     v-model="fields.dislikeReason"
                                     v-on:keyup="validation.dislikeReason = null"
                                     placeholder="Please provide feedback on this product here (max 280 characters)" maxlength="280"></textarea>
                           <div class="error-message" v-for="message in validation.dislikeReason">{{ message }}</div>
                        </div>

                        <!-- firstname -->
                        <firstname></firstname>

                        <!-- lastname -->
                        <lastname></lastname>

                        <!-- email and phone -->
                       <email></email>

                        <!-- select: country -->
                        <country></country>

                        <!-- checkbox: feedbackConcent -->
                        <feedbackConsent></feedbackConsent>

                        <!-- checkbox: marketing_oncent -->
                        <marketingConsent></marketingConsent>

                        <!-- submit, validation and confirmation -->
                        <submit-confirmation></submit-confirmation>

                    </div>
                </form>
                <thankyou-message v-if="status.complete"></thankyou-message>
            </div>
        </div>
    </div>

</template>

<script>

    import mixin from './mixin.js'

    let fillable = {
        notPurchasedReason: '',
        dislikeReason: '',
        firstname: '',
        lastname: '',
        email: '',
        country: '',
        feedbackConsent: '',
        marketing_consent: true,
        referrer: window.location.pathname,
        b2c: 'yes',
        b2b: 'no',
        yes_Rating: false,
        no_Rating: true,
        travelDeviceModel: '',
        timeOnMachineDatestamp : '',
        marketingConsentDate: (new Date()).toISOString(),
    }

    export default {
        data() {
            return {
                form: {
                    name: '',   // form name
                    origin: ''  // form origin ( page )
                },
                status: {
                    idle: null,
                    step: [],
                    last_step: [],
                    errors: false,
                    complete: false,
                },
                response: {
                    type: '', // validation or confirmation
                    message: '' // response
                },
                holdingValue: {},
                fields: { ...fillable },
                validation: {}
            }
        },
        mixins: [ mixin ],
        methods: {
            updateView(e) {
              this.validation.notPurchasedReason = null
              if (e.target.options[e.target.options.selectedIndex]) {
                  let step = e.target.options[e.target.options.selectedIndex].dataset.nextstep
                  this.status.step = step ? step : [];
              }
            }
        }
    }
</script>
